
// place to init your script on DOM load
document.addEventListener('DOMContentLoaded', function() {
    InstaFeedPlugin.footer();
    Carousel3DPlugin.init();
});
